import React, { useState } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { isMobileStyleMixin, useIsMobile, Extender } from '@amzn/storm-ui';

const TextContent = /*#__PURE__*/styled('section').withConfig({
  componentId: "sc-storm-ui-30062554__sc-17kbs9k-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:flex-start;flex-grow:1;", ""], isMobileStyleMixin(css(["padding:", " 0 0 0;> *:first-child{margin-top:0;}"], ({
  theme
}) => theme.spacing.medium)));
const contentTeaserMixin = /*#__PURE__*/css(["-webkit-mask-image:-webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,1)),to(rgba(0,0,0,0)));mask-image:gradient(linear,left top,left bottom,from(rgba(0,0,0,1)),to(rgba(0,0,0,0)));"]);
const Passthrough = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, children);
const TeaserTextSubSection = /*#__PURE__*/styled('section').withConfig({
  componentId: "sc-storm-ui-30062554__sc-17kbs9k-1"
})(["", ""], isMobileStyleMixin(css(["margin-bottom:", ";position:relative;", ";"], ({
  $teaserMode
}) => $teaserMode ? '0' : '14px', ({
  $teaserMode
}) => $teaserMode ? contentTeaserMixin : '')));
const TextContainer = ({
  children,
  renderTeaser,
  hideLabel,
  revealLabel,
  extended = false,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(extended);
  const MobileExtender = useIsMobile() ? Extender : Passthrough;
  return /*#__PURE__*/React.createElement(TextContent, props, renderTeaser ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TeaserTextSubSection, {
    $teaserMode: !isOpen
  }, renderTeaser), /*#__PURE__*/React.createElement(MobileExtender, {
    label: isOpen ? hideLabel : revealLabel,
    handleClick: () => setIsOpen(!isOpen),
    isOpen: isOpen
  }, children)) : /*#__PURE__*/React.createElement(React.Fragment, null, children));
};
TextContainer.propTypes = {
  /**
   * Content rendered into the content teaser area on mobile. If no `renderTeaser={...}`
   * is supplied, the content will be displayed without the teaser.
   */
  renderTeaser: PT.node,
  /**
   * Text to indicate clicking will hide the content
   */
  hideLabel: PT.string,
  /**
   * Text to indicate clicking will reveal the content
   */
  revealLabel: PT.string,
  /**
   * All content is initially visible
   */
  extended: PT.bool
};
TextContainer.defaultProps = {
  renderTeaser: undefined,
  hideLabel: 'Hide',
  revealLabel: 'Show more',
  extended: false,
  children: undefined
};

export { TextContainer as T };
//# sourceMappingURL=TextContainer-CyMDVZHI.js.map
